import { takeLatest, put, call } from 'redux-saga/effects';

import {
  registerRequest,
  registerFail,
  registerSuccess,
  resendRequest,
  resendSuccess,
  resendFail,
} from './actions';
import RegisterService from '../../../services/RegisterService';
import { getErrorMessage } from '../../util';
import { logInRequest } from '../auth/actions';

function* requestRegistration({ payload }: ReturnType<typeof registerRequest>) {
  try {
    yield call(RegisterService.register, payload);
    yield put(registerSuccess());
    yield put(logInRequest({ email: payload.email, password: payload.password, rememberMe: false }));
  } catch (e) {
    yield put(registerFail(getErrorMessage(e)));
  }
}

function* resendEmail({ payload }: ReturnType<typeof resendRequest>) {
  try {
    yield call(RegisterService.resend, payload);
    yield put(resendSuccess());
  } catch (e) {
    yield put(resendFail(getErrorMessage(e)));
  }
}

export default [
  takeLatest(registerRequest.type, requestRegistration),
  takeLatest(resendRequest.type, resendEmail),
];
